(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/poker-react/components/nav-menu/assets/javascripts/poker-nav-menu.js') >= 0) return;  svs.modules.push('/modules/poker-react/components/nav-menu/assets/javascripts/poker-nav-menu.js');
"use strict";


const _ReactRouterDOM = ReactRouterDOM,
  Link = _ReactRouterDOM.Link,
  useLocation = _ReactRouterDOM.useLocation;
const _svs$ui$ReactItemsMen = svs.ui.ReactItemsMenu,
  ItemsMenu = _svs$ui$ReactItemsMen.ItemsMenu,
  LinkItem = _svs$ui$ReactItemsMen.LinkItem,
  ItemsMenuIcon = _svs$ui$ReactItemsMen.ItemsMenuIcon;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_SM = _svs$components$lbUti.BREAKPOINT_SM;
const MenuTabTypes = svs.poker_react.components.common.constants.MenuTabTypes;
const PokerNavMenu = _ref => {
  let routes = _ref.routes;
  const location = useLocation();
  const isSmallScreen = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  const activeRoutes = routes.filter(route => route.active);
  return React.createElement(ItemsMenu, {
    ariaLabel: "Meny f\xF6r Poker",
    branding: "poker-react",
    centered: true,
    className: "poker-nav",
    compact: isSmallScreen
  }, activeRoutes.map(route => {
    const selected = location.pathname === "/".concat(route.path) || location.pathname === '/' && route.path === 'aktuellt';
    return React.createElement(LinkItem, {
      "aria-label": route.tabType === MenuTabTypes.Ranking ? 'Player of the year' : undefined,
      Component: Link,
      "data-testid": "poker-route",
      key: route.path,
      label: isSmallScreen && route.shortLabel || route.label,
      selected: selected,
      to: route.path
    }, Boolean(route.icon) && isSmallScreen && React.createElement(ItemsMenuIcon, {
      icon: route.icon,
      position: "top",
      size: "200"
    }));
  }));
};
setGlobal('svs.poker_react.components.PokerNavMenu', PokerNavMenu);

 })(window);